"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAccordion = void 0;
var palette_1 = require("../../../theme/global/palette");
var shape_1 = require("../../../theme/global/shape");
var shadows_1 = require("../../global/shadows");
exports.MuiAccordion = {
    root: {
        border: 'none',
        borderTop: 'none',
        borderColor: palette_1.palette.grey[300],
        boxShadow: shadows_1.boxShadow.none,
        '&.Mui-expanded': {
            backgroundColor: palette_1.palette.grey[200],
        },
        '&:hover': {
            backgroundColor: palette_1.palette.grey[200],
        },
        '&:before': {
            backgroundColor: 'transparent',
        },
    },
    rounded: {
        borderRadius: shape_1.shape.borderRadius,
    },
    expanded: {},
};
